import { render, staticRenderFns } from "./MappingHeaderSelect.vue?vue&type=template&id=81ce84ee"
import script from "./MappingHeaderSelect.vue?vue&type=script&lang=ts"
export * from "./MappingHeaderSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports